export default {
  setChangeDate (state: {[key:string]: string}, value: string) {
    state.changeDate = value
  }
}
